import { useTexts } from 'utils/useTexts';
import Footer from '@components/shared/Footer/Footer';
import CurrentAddressInfoManuallyForm from '@components/CurrentAddressInfoForm/CurrentAddressInfoManuallyForm';

const CurrentAddressInfoManually = () => {
  const { t } = useTexts();

  return (
    <>
      <CurrentAddressInfoManuallyForm />

      <Footer text={t('enterLicensePlate.footer.footerText')} />
    </>
  );
};

export default CurrentAddressInfoManually;
